import React, { Component } from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import DateTimePicker from 'react-widgets/lib/DateTimePicker';
import moment from 'moment';
import i18next from 'i18next';
import withCustomComponent from 'ui/components/withCustomComponent';

require('react-widgets/dist/css/react-widgets.css');

@withCustomComponent('DateInputField')
@withTranslation()
@observer
class DateInputField extends Component {
  constructor(props) {
    super(props);

    this.state = { touched: false };
  }

  onChange = (date) => {
    this.setState({ touched: true });
    if (!date) {
      this.props.onChange(this.props.name, null);
      return;
    }
    const input = this.props;
    let currentDate = input.value ?? new Date();
    let clone = moment(currentDate).clone().toDate();
    if (input.showTimeSelect) {
      clone.setMinutes(date.getMinutes());
      clone.setHours(date.getHours());
    } else {
      clone.setYear(date.getFullYear());
      clone.setMonth(date.getMonth());
      clone.setDate(date.getDate());
    }

    this.props.onChange(this.props.name, clone);
  };

  onFocus = () => {
    this.setState({ touched: true });
  };

  render() {
    const input = this.props;
    const hasErrors = input.errors && input.errors.length > 0;
    const { touched } = this.state;

    const dateIconElement = <i className="icon-calendar-small"></i>;
    const timeIconElement = <i className="icon-time"></i>;

    return (
      <div
        className={`form-group ${
          input.className ? input.className : ''
        } custom-datepicker ${input.showTimeSelect == true ? 'time' : 'date'}`}
      >
        {input.label && (
          <label className="control-label" htmlFor={input.id}>
            {input.label}
          </label>
        )}
        <DateTimePicker
          id={input.id}
          culture={i18next.language}
          step={15}
          value={
            input.value && moment(input.value).isValid
              ? moment(input.value).toDate()
              : null
          }
          onChange={(value) => {
            this.onChange(value);
          }}
          containerClassName="form-control"
          date={input.showTimeSelect != true}
          dateIcon={dateIconElement}
          time={input.showTimeSelect == true}
          timeIcon={timeIconElement}
          disabled={input.disabled == true}
          {...this.props.customProps}
        ></DateTimePicker>
        {hasErrors && (
          <div className="invalid-feedback">{input.errors.join(', ')}</div>
        )}
        {input.helpText && (
          <small class="form-text text-muted">{input.helpText}</small>
        )}
      </div>
    );
  }
}

DateInputField.propTypes = {
  onChange: PropTypes.func.isRequired,
};

export default DateInputField;
